import React from "react";

import telegram_icon from '../../../assets/icons/telegram.svg';
import instagram_icon from '../../../assets/icons/instagram.svg';
import tiktok_icon from '../../../assets/icons/tiktok.svg';

import '../style/Contacts.css';
import { t } from "i18next";

const Contacts = () => {
    return (
        <section className="about_content">
            <div className="content">
                <h1 className="m_0">{t('contacts')}</h1>
            </div>
            <iframe
                className="map_content"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d282.6948900202781!2d76.88084805128575!3d43.19534423979491!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x388369276e8c4a03%3A0xe2e0b3b13f3e43a2!2sKdl%20Olimp%2C%20Kliniko-Diagnosticheskaya%20Laboratoriya!5e0!3m2!1sen!2skz!4v1760451133953!5m2!1sen!2skz"
                width="100%"
                height="400"
                borderRadius="10px"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Agroland ақпараттық беті"
            ></iframe>
            <div className="content">
                <div className="contact-details">
                    <h3>{t('our_contacts')}</h3>
                    <hr className="divider"></hr>
                    <div className="contact-social-content">
                        <div className="contact-details">
                            <ul>
                                <li>
                                    <strong>{t('phone')}:</strong> +7 (707) 538 88 35
                                </li>
                                <li>
                                    <strong>{t('mail')}:</strong> support@agroland.kz
                                </li>
                                <li>
                                    <strong>{t('address')}:</strong> {t('address_loc')}
                                </li>
                            </ul>
                        </div>
                        <div className="social-links">
                            <div>
                                <h3>{t('social_networks')}</h3>
                                <ul className="fooder_list navigation_fooder_list">
                                    <li><img src={telegram_icon} alt="telegram" /></li>
                                    <li><a href="https://www.instagram.com/agroland.kz?igsh=M2xieDF1bDdwYWFl&utm_source=qr" target="_blank" rel="noreferrer"><img src={instagram_icon} alt="instagram" /></a></li>
                                    <li><a href="https://www.tiktok.com/@agroland.kz?_t=ZM-8wXe6Zcgigi&_r=1" target="_blank" rel="noreferrer"><img src={tiktok_icon} alt="tiktok" /></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contacts;